export default function () {

    function findString(a, b) {
        $("p, main h1, main h2, main h3, main h4, main h5, main li, td").html(function () {
            return $(this).html().replace(a, `<a class="Tooltip-label">${a.replace('[', '').replace(']', '')}<span class="Tooltip Tooltip--overlay Tooltip--arrowN">
                <span class="Tooltip-content">
                    <span class="Tooltip-header">
                        <span>
                            <span>${a.replace('[', '').replace(']', '')}</span>
                        </span>
                        <span>
                            <svg class="svg svg--cut"><use xlink:href="#cut"></use></svg>
                    </span>
                </span>
                <span class="Tooltip-body">${b}</span>
            </span>
                <span class="Tooltip-arrow"></span>
            </span>
            <span class="Tooltip-label-icon"></span>
            </a>`);
        })
    }

    if (document.getElementById('TooltipDictionary') === null) return

    let ttObj = JSON.parse(document.getElementById('TooltipDictionary').value)

    for (const prop in ttObj) {
        findString(`${prop}`, `${ttObj[prop]}`)
    }

    let ttLabel = document.getElementsByClassName('Tooltip-label')
    let ttLength = ttLabel.length

    if (!ttLength) return

    for (let i = 0; i < ttLength; i++){
        ttLabel[i].addEventListener('click', function (e) {  //mouseenter
            handleTTlabel(e)
        });

        ttLabel[i].addEventListener('mouseenter', function (e) {  //mouseenter
            handleTTlabel(e)
        });

        ttLabel[i].addEventListener('mouseleave', function (e) {
            let ttElem = e.target.querySelector('.Tooltip');
            ttElem.classList.remove('is-active')
        });

        function handleTTlabel(e) {
            let ttElem = e.target.querySelector('.Tooltip');
            if (ttElem.classList.contains('is-active')) {
                return;
                ttElem.classList.remove('is-active')
            } else {
                ttElem.style.top = e.target.offsetTop - ttElem.querySelector('.Tooltip-content').offsetHeight - e.target.offsetHeight + "px"
                ttElem.classList.add('is-active')
            }
        }

    }

    $('body').off('click.tooltipCheck').on('click.tooltipCheck', function (e) {
        e.stopImmediatePropagation();
        if (e.target.classList.contains('Tooltip-label')) return;
        $('.Tooltip').removeClass('is-active')
    });

}